// Phone line metadata display: "Mobile (AT&T)" next to a lead's number.
import { fmtPhone } from './format.js';

const LABELS = { mobile: 'Mobile', landline: 'Landline', voip: 'VoIP', tollfree: 'Toll-Free' };

/** 'Mobile' / 'VoIP' / … or '' when the line type is unknown or not yet looked up. */
export const lineTypeLabel = (t) => LABELS[String(t || '').toLowerCase()] || '';

/** '(Mobile · AT&T)'-style badge text: 'Mobile (AT&T)', 'VoIP', or '' when nothing is known. */
export function lineBadge(lead) {
  const type = lineTypeLabel(lead?.phoneLineType);
  const carrier = String(lead?.phoneCarrier || '').trim();
  if (!type) return '';
  return carrier ? `${type} (${carrier})` : type;
}

/** '(555) 012-3456 • Mobile (AT&T)' — the number alone when the line is unknown. */
export function phoneWithLine(lead) {
  const badge = lineBadge(lead);
  return badge ? `${fmtPhone(lead?.phone)} • ${badge}` : fmtPhone(lead?.phone);
}

/** Tailwind classes for a line-type chip. */
export function lineTone(type) {
  switch (String(type || '').toLowerCase()) {
    case 'mobile': return 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30';
    case 'landline': return 'bg-sky-500/15 text-sky-300 border-sky-500/30';
    case 'voip': return 'bg-amber-500/15 text-amber-300 border-amber-500/30';
    case 'tollfree': return 'bg-violet-500/15 text-violet-300 border-violet-500/30';
    default: return 'bg-white/10 text-white/60 border-white/15';
  }
}
